globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.LimitlessPlugins = appCustomerSpace.LimitlessPlugins || {};
appCustomerSpace.LimitlessPlugins.DatePickers = appCustomerSpace.LimitlessPlugins.DatePickers || {};

appCustomerSpace.LimitlessPlugins.DatePickers.Single = (function(){

  Single.selector = '[data-plugin="limitless.datepickers.single"]';

  Single.init = function($html) {
    $html.find(Single.selector).each(function() {
      new Single($(this));
    })
  }

  function Single($html) {
    this.$html = $html;
    this.init();
  }

  Single.prototype = {
    init: function(){
      var Single = this,
          options = this.$html.data('plugin-options') || {},
          defaults = {
            singleDatePicker: true,
            showDropdowns: true,
            autoApply: true,
            autoUpdateInput: false,
            locale: {
              format: 'DD/MM/YYYY'
            }
          };

      Single.$html.daterangepicker(
        $.extend({}, defaults, options, true),
        function(start, end, label) {
          window.preventHidingDropdowns = true;
          Single.$html.val(start.format(this.locale.format)).change();
        }
      );
    }
  }

  return Single;
})();
